import { Box } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import ContentWrap from "../../../DocLayout/Content/Index";
import CodeSnippet from "../../../components/CodeSnippet";
import { codeMap } from "@/PageCodeComponents/MerchantUserWalletModeAPI";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import {
  USER_WITHDRAW_TO_CWALLET,
  USER_WITHDRAW_TO_NETWORK,
  USER_WITHDRAW_TO_RECORD,
  USER_WITHDRAW_TO_RECORD_LIST,
} from "@/config";
import { Trans } from "react-i18next";
import PostRequest from "@/components/PostRequest";
import { useAuthContext } from "@/auth/useAuthContext";

export default function Index() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  const user_withdraw_to_cwallet = {
    response: `{
  "code": 10000,
  "msg": "success",
  "data": {
    "recordId": "20240322032xxxxxxxx0660770816"
  }}`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${check ? USER_WITHDRAW_TO_CWALLET : "***"}"
    args := []byte(${`{
        "coinId": 1280,
        "userId": "1709021102608",
        "cwalletUser": "9558861",
        "orderId": "testuserwithdrawcwallet111",
        "amount": "0.002"
    }`})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }    
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${check ? USER_WITHDRAW_TO_CWALLET : "***"}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("coinId", 1280);
    map.put("userId", "1709021102608");
    map.put("cwalletUser", "9558861");
    map.put("orderId", "testuserwithdrawcwallet111");
    map.put("amount", "0.002");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
      signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
      responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
        tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
        hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? USER_WITHDRAW_TO_CWALLET : "***"}"
  content = {
    "coinId": 1280,
    "userId": "1709021102608",
    "cwalletUser": "9558861",
    "orderId": str(int(time.time() * 1000)),
    "amount": "0.01"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? USER_WITHDRAW_TO_CWALLET : "***"}';
  const args = JSON.stringify({
    'coinId': 1280,
    'userId': '1709021102608',
    'cwalletUser': '9558861',
    'orderId': '121231313',
    'amount': '0.001',
      });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
  signText += args;
  }
  
  const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');
  
  const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
  };
  
  const req = https.request(path, options, (res) => {
  let respData = '';
  
  res.on('data', (chunk) => {
    respData += chunk;
  });
  
  res.on('end', () => {
    console.log('Response:', respData);
  });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? USER_WITHDRAW_TO_CWALLET : "***"}";
  $content   = [
    "coinId"=>1280,
    "cwalletUser"=>"",
    "orderId"=>"",
    "userId" => "",
    "amount"=>"1",
  ];  
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);`,
      example_code: ``,
      example_code2: ``,
    },
  };

  const user_withdraw_to_record = {
    response: `{
  "code": 10000,
  "msg": "success",
  "data": {
    "record": {
      "userId": "6322718677975328",
      "recordId": "202403220324441771015126690828288",
      "withdrawType": "Cwallet",
      "coinId": 1280,
      "chain": "Cwallet OS",
      "orderId": "777777779",
      "txId": "",
      "coinSymbol": "USDT",
      "cwalletUser": "35255142",
      "toMemo": "",
      "amount": "0.002",
      "status": "Success"
    }
  }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${check ? USER_WITHDRAW_TO_RECORD : "***"}"
    args := []byte(${`{
        "recordId": "202403010604081763445093768892416"
    }`})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }    
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${check ? USER_WITHDRAW_TO_RECORD : "***"}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("recordId", "202403010604081763445093768892416");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
      responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? USER_WITHDRAW_TO_RECORD : "***"}"
  content = {
    "recordId": "202403010604081763445093768892416",
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
        "Content-Type": "application/json;charset=uf8",
        "Appid": app_id,
        "Sign": server_sign,
        "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? USER_WITHDRAW_TO_RECORD : "***"}';
  const args = JSON.stringify({
      'recordId': '202403010604081763445093768892416',
        });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac('sha256', appSecret)
    .update(signText)
    .digest('hex');
  
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Appid': appId,
      'Sign': sign,
      'Timestamp': timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = '';
  
    res.on('data', (chunk) => {
      respData += chunk;
    });
  
    res.on('end', () => {
      console.log('Response:', respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? USER_WITHDRAW_TO_RECORD : "***"}";
  $content   = [
    "recordId"=>"202403220324441771015126690828288",
  ];  
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
      "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  `,
      example_code: ``,
      example_code2: ``,
    },
  };
  const user_withdraw_to_record_list = {
    response: `{
  "code": 10000,
  "msg": "success",
  "data": {
    "records": [
      {
        "userId": "6322718677975328",
        "recordId": "202403130916211767842120296566784",
        "withdrawType": "Network",
        "coinId": 1891,
        "chain": "ETH_SEPOLIA",
        "orderId": "6322809704579360",
        "txId": "0x839abd6d240c371bf41749263f2de4c1b6a4bd9030df2079746b14486f2c666d",
        "coinSymbol": "TETH",
        "fromAddress": "0xBc87f0Ba629bbe92438F04093EBce93F",
        "ToAddress": "0x12438F04093EBc87f0Ba629bbe93F2451711d967",
        "toMemo": "",
        "amount": "0.001",
        "status": "Success",
        "fee": {
          "coinId": 1891,
          "coinSymbol": "TETH",
          "amount": "0.001"
        }
      },
      ...
    ],
    "nextId": "c5f5026e18f7672f7d5eb5ac79205891"
  }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${check ? USER_WITHDRAW_TO_RECORD_LIST : "***"}"
    args := []byte(${`{
      "userId": "1709021102608"
    }`})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
      signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }
    
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${check ? USER_WITHDRAW_TO_RECORD_LIST : "***"}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("userId", "1709021102608");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
      signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
      responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? USER_WITHDRAW_TO_RECORD_LIST : "***"}"
  content = {
    "userId": "1709021102608",
    # "coinId": 272366,
    # "address": "kava1fc72crkczxzpdkn0xlxt65mklfywt485jqwazq",
    # "chain": "DOGE",
    # "startAt":  1704042061,
    # "endAt": 1708426738,
    # "nextId": ""
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? USER_WITHDRAW_TO_RECORD_LIST : "***"}';
  const args = JSON.stringify({
    'userId': '1709021102608',
    # 'coinId': 272366,
    # 'address': 'kava1fc72crkczxzpdkn0xlxt65mklfywt485jqwazq',
    # 'chain': 'DOGE',
    # 'startAt':  1704042061,
    # 'endAt': 1708426738,
    # 'nextId': ''
      });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac('sha256', appSecret)
    .update(signText)
    .digest('hex');
  
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Appid': appId,
      'Sign': sign,
      'Timestamp': timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = '';
  
    res.on('data', (chunk) => {
      respData += chunk;
    });
  
    res.on('end', () => {
      console.log('Response:', respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? USER_WITHDRAW_TO_RECORD_LIST : "***"}";
  $content   = [
      "userId" => "6322718677975328",
  ];  
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <div>
      {/* 用户提现到区块链 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="apis-related-to-user-withdrawals" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_39")}
            </Box>
            <Box id="user-withdrawals-to-blockchain" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_40")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_41")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_42")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_NETWORK} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "coinId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "address",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_43")}`,
                },
                {
                  name: "memo",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_withdraw_to_network"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 用户提现到区块链 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_46")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_network"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* Webhook 通知 - User Withdrawal */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box id="webhook-notifications-user-withdrawal" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_47")}
            </Box>
            <Box className="desc code">
              {currentLang.value === "en" ? (
                <Trans
                  i18nKey={"merchant_user_wallet_mode_API.text_7_"}
                  t={translate as any}
                >
                  s
                  <a href={"#get-user-withdrawal-records"} className="link">
                    Just a placeholder
                  </a>
                </Trans>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "merchant_user_wallet_mode_API.text_7"
                    ) as any,
                  }}
                />
              )}
            </Box>
            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_8")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "type",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_120"),
                },
                {
                  name: "msg",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "msg.recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "msg.orderId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_44_"
                  )}`,
                },
                {
                  name: "msg.userId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "msg.coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "msg.coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "msg.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_85_"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              {translate("merchant_user_wallet_mode_API.text_50")}
              {currentLang.value === "en" ? (
                <Trans
                  i18nKey={"merchant_user_wallet_mode_API.text_51"}
                  t={translate as any}
                >
                  s
                  <a href={"#get-user-withdrawal-records"} className="link">
                    s
                  </a>
                  s
                </Trans>
              ) : (
                <div
                  className="code"
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "merchant_user_wallet_mode_API.text_51"
                    ) as any,
                  }}
                />
              )}
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "UserWithdrawal",
  "msg": {
    "recordId": "2024031312073317...",
    "orderId": "6322851679858976",
    "userId": "6322718677975328",
    "coinId": 1891,
    "coinSymbol": "TETH",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 用户提现到Cwallet账户 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="user-withdrawals-to-cwallet-account" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_52")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_53")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_CWALLET} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "coinId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "cwalletUser",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_54"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_55")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_55_" : "text_44"
                    }`
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_withdraw_to_cwallet[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 用户提现到Cwallet账户 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.recordId",
                  type: "String",
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_55_1" : "text_46"
                    }`
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_56"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_cwallet"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-withdrawal-records" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_57")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_58")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_RECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },

                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_59"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_withdraw_to_record[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.record.userId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.record.chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "data.record.cwalletUser",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_54"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.fromAddress",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_66_"
                  )}`,
                },
                {
                  name: "data.record.toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_66")}`,
                },
                {
                  name: "data.record.toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_67")}`,
                },
                {
                  name: "data.record.txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_68")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_85_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.orderId",
                  type: "String",
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_68_1" : "text_44_"
                    }`
                  ),
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
                {
                  name: "data.record.fee",
                  type: "Object",
                  desc: `${translate("merchant_user_wallet_mode_API.text_69")}`,
                },
                {
                  name: "data.record.fee.coinId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_92")}`,
                },
                {
                  name: "data.record.fee.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_70")}`,
                },
                {
                  name: "data.record.fee.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_71")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现历史记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-withdrawal-history" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_72")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_73")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_WITHDRAW_TO_RECORD_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "toAddress",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang?.value === "en" ? "text_32" : "text_31"
                    }`
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_withdraw_to_record_list[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户提现历史记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.records[index].userId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.records[index].withdrawType",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_64_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_63")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_64")}`,
                },
                {
                  name: "data.records[index].chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang.value === "en" ? "text_44_1" : "text_44_"
                    }`
                  ),
                },
                {
                  name: "data.records[index].cwalletUser",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_65")}`,
                },
                {
                  name: "data.records[index].fromAddress",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_74_"
                  )}`,
                },
                {
                  name: "data.records[index].toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_74")}`,
                },
                {
                  name: "data.records[index].toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_75")}`,
                },
                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
                {
                  name: "data.records[index].txId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_68_"
                  )}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_85_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].fee",
                  type: "Object",
                  desc: `${translate("merchant_user_wallet_mode_API.text_69")}`,
                },
                {
                  name: "data.records[index].fee.coinId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_92")}`,
                },
                {
                  name: "data.records[index].fee.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_70")}`,
                },
                {
                  name: "data.records[index].fee.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_71")}`,
                },
                {
                  name: "data.nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            `merchant_user_wallet_mode_API.${
                              currentLang?.value === "en"
                                ? "text_32"
                                : "text_30_"
                            }`
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_withdraw_to_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
